import { BaseIcon } from 'src/components/BaseIcon';
import { InfoHelper } from '../InfoHelper';
import React from 'react';
import { TAssetBlockProps } from './AssetBlock.types';
import s from './AssetBlock.module.scss';

export const AssetBlock: React.FC<TAssetBlockProps> = ({
  className,
  icon,
  title,
  subtitle,
  description,
  theme = 'dark',
  aspectRatio = 107,
  onClick,
  onThreeDotsClick,
}: TAssetBlockProps) => {
  const MainComponent: any = onClick ? 'button' : 'div';

  return (
    <div
      className={`${className} ${s.blockOuter} ${s[`theme-${theme}`]}`}
      style={{ paddingTop: aspectRatio + '%' }}>
      <MainComponent className={s.block} type="button" onClick={onClick}>
        <BaseIcon className={s.mainIcon} icon={icon} />

        <div className={s.detailsSize}>
          <h3 className={s.title}>{title}</h3>
          <p className={s.subtitle}>{subtitle}</p>
        </div>
      </MainComponent>

      {/* <button type="button" className={s.dragButton}>
        <BaseIcon className={s.dragIcon} icon="drag" />
      </button> */}

      {onThreeDotsClick && (
        <button onClick={onThreeDotsClick} type="button" className={s.threeDots}>
          <BaseIcon icon="more-horizontal" size={10} />
        </button>
      )}

      {description && <InfoHelper className={s.infoButton} size={8} info={description} />}
    </div>
  );
};
